/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { PermissionException } from './PermissionException';
import { Setting } from './Setting';
const TierRestrictedExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['restrictedSetting', Setting, 'restricted_setting'],
]), PermissionException);
export class TierRestrictedException extends PermissionException {
    static decode(input) {
        return TierRestrictedExceptionParser.decode(input).map(res => new TierRestrictedException(res));
    }
    static unsafeDecode(input) {
        return TierRestrictedException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierRestrictedExceptionParser.encode(data);
    }
    static schema() {
        return TierRestrictedExceptionParser.schema();
    }
}
